import type { Enums } from '@xleddyl/types'

type Props = (scopes: Enums<'ORGANIZATION_RBAC_SCOPE'>[]) => boolean

export const useRbac = (): Props => {
   const { $rbac } = useNuxtApp()
   return $rbac as Props
}
